var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow left"),React.createElement("g",{"className":"nc-icon-wrapper","strokeLinecap":"square","strokeLinejoin":"miter","strokeWidth":"2","fill":"#111111","stroke":"#111111","key":1},[React.createElement("line",{"data-cap":"butt","data-color":"color-2","fill":"none","strokeMiterlimit":"10","x1":"46","y1":"24","x2":"3","y2":"24","strokeLinecap":"butt","key":0}),React.createElement("polyline",{"fill":"none","stroke":"#111111","strokeMiterlimit":"10","points":"17,10 3,24 17,38 ","key":1})])]);
}

ArrowLeft.defaultProps = {"viewBox":"0 0 48 48","width":"48","height":"48"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
